/**
 * Booking details opener — vanilla TS replacement for the inline `<script>`
 * block previously embedded in `_booking_details_opener.html.erb`.
 *
 * Wires the legacy `#j-booking-details-sidepanel` to the global eventbus:
 * any pack that emits `window.EVENTS.BOOKING_DETAILS` with `{ bookingId }`
 * triggers the sidepanel to open and ajax-loads the booking row's details.
 *
 * The booking-details URL is server-rendered (locale + subdomain interpolation
 * happens in Rails) and read from `data-booking-details-url` on the partial's
 * marker element — same pattern as `admin_sidebar.ts`.
 */

import $ from "jquery"

declare global {
  interface Window {
    __bookingDetailsOpenerInitialised?: boolean
    bookingDetails?: (payload: { bookingId: number | string }) => void
    openBookingDetailsSidepanel?: () => void
    eventbus?: {
      on: (event: string, handler: (e: CustomEvent<{ bookingId: number | string }>) => void) => void
      emit: (event: string, payload: unknown) => void
    }
    EVENTS?: { BOOKING_DETAILS: string; [key: string]: string }
  }
}

const MARKER_SELECTOR = "[data-booking-details-opener]"
const URL_ATTR = "data-booking-details-url"

if (!window.__bookingDetailsOpenerInitialised) {
  window.__bookingDetailsOpenerInitialised = true

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
}

function init(): void {
  const marker = document.querySelector<HTMLElement>(MARKER_SELECTOR)
  if (!marker) return

  const url = marker.getAttribute(URL_ATTR)
  if (!url) return

  window.bookingDetails = ({ bookingId }) => {
    window.openBookingDetailsSidepanel?.()
    $.ajax({ type: "GET", url, data: { booking_id: bookingId } })
  }

  window.eventbus?.on(window.EVENTS?.BOOKING_DETAILS ?? "booking details", ({ detail: { bookingId } }) => {
    window.bookingDetails?.({ bookingId })
  })
}

export {}
